import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyCCK77kMHw1PVdkVYCq0Z0ZNmyxWntsfzU",
    authDomain: "metal-imprint-462104-h1.firebaseapp.com",
    projectId: "metal-imprint-462104-h1",
    storageBucket: "metal-imprint-462104-h1.firebasestorage.app",
    messagingSenderId: "135790224514",
    appId: "1:135790224514:web:379356191401bee014c09b",
    measurementId: "G-ZM7645G37X"
  };
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app, 'user-sessions');
export const storage = getStorage(app);
export const auth = getAuth(app); 